import styled from "styled-components";
import { breakpoints, Size } from "@trailhead/asurion-ui";

export const LGSectionContainer = styled.div<{
    justifyContent?: string;
    additionalProps?: string;
    removeMaxWidth?: boolean;
}>`
  margin: 0 auto;
  padding: 1rem 1rem;
  display: flex;
  flex-direction: row;
  justify-content: ${({ justifyContent }) => justifyContent ?? "center"};
  ${({ additionalProps }) => additionalProps ?? ""}

  ${breakpoints.mdOnly} {
    padding: 2rem 1.5rem;
  }

  ${breakpoints.lg} {
    padding: 3rem 1.5rem;
    ${({ removeMaxWidth }) =>
        !removeMaxWidth && `max-width: ${Size.LG - 80}px;`}
  }
`;

export const XLSectionContainer = styled(LGSectionContainer)`
  ${breakpoints.xl} {
    padding: 3rem;
  }
`;

export const XXLSectionContainer = styled(XLSectionContainer)`
  ${breakpoints.xxl} {
    ${({ removeMaxWidth }) => !removeMaxWidth && `max-width: ${Size.XL}px;`}
  }
`;